import React, {useEffect} from 'react';
import {
    Col,
    Row
} from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import BusPickupList from "./_list";
import BusPickupForm from "./_form";
import {showLoader} from "../../../components/loader/loader";
import {clearState, setApp, setCategory, setUdn, setViewMode, setLoading} from "../../../redux/actions/generalActions/mainActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {connect} from "react-redux";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

const BusPickup = (props) => {
    // Modo de vista: LIST, FORM
    const { loading } = props.mainProps
    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const createItem = () => {
        props.setForm()
        ModalFormContainer(BusPickupForm, { data: null, Form: BusPickupForm });
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <BusPickupList />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    clearListState,
});

export default connect(mapStateToProps, mapActionsToProps)(BusPickup)